/* Carrito lateral: abre con el icono del header y con cualquier boton
   "Agregar", cambia cantidades, elimina y suma ofertas sin recargar. */
(function () {
  'use strict';
  if (window.__oeCart) return;
  window.__oeCart = true;

  var root = null;
  var mount = null;
  var busy = false;
  var lastFocus = null;
  var previewId = new URLSearchParams(location.search).get('preview_theme_id');

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function setBusy(on) {
    busy = on;
    if (root) root.classList.toggle('is-busy', on);
  }

  function updateCount(n) {
    all('.oe-hdr__cart').forEach(function (a) {
      var c = q('.oe-hdr__count', a);
      a.setAttribute('aria-label', 'Carrito (' + n + ')');
      if (n > 0) {
        if (!c) { c = document.createElement('span'); c.className = 'oe-hdr__count'; a.appendChild(c); }
        c.textContent = n; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
      } else if (c) { c.remove(); }
    });
  }

  function refresh() {
    var url = '/?sections=oe-cart-drawer&t=' + Date.now() + (previewId ? '&preview_theme_id=' + encodeURIComponent(previewId) : '');
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var tmp = document.createElement('div');
        tmp.innerHTML = j['oe-cart-drawer'] || '';
        var inner = q('[data-oe-cd-inner]', tmp);
        if (!inner) return;
        var cur = q('[data-oe-cd-inner]', mount);
        var keepScroll = cur ? q('.oe-cd__scroll', cur).scrollTop : 0;
        if (cur) cur.replaceWith(inner); else mount.innerHTML = inner.outerHTML;
        var sc = q('.oe-cd__scroll', mount);
        if (sc) sc.scrollTop = keepScroll;
        updateCount(Number(inner.getAttribute('data-count')) || 0);
      });
  }

  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('oe-cd-lock');
    var panel = q('.oe-cd__panel', root);
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('oe-cd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function post(path, body) {
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function change(key, qty, row) {
    if (busy) return;
    setBusy(true);
    if (row && qty === 0) row.classList.add('is-out');
    var wait = row && qty === 0 ? new Promise(function (r) { setTimeout(r, 220); }) : Promise.resolve();
    Promise.all([post('/cart/change.js', { id: key, quantity: qty }), wait])
      .then(refresh)
      .catch(function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  function addVariant(id, btn) {
    if (busy) return;
    setBusy(true);
    if (btn) btn.classList.add('is-loading');
    post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function (r) { if (btn) btn.classList.add('is-added'); return r; })
      .then(refresh)
      .catch(function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  // Confirmacion breve en el boton que se toco
  function added(btn) {
    if (!btn) return;
    var old = btn.textContent;
    btn.classList.add('is-added'); btn.textContent = '¡Agregado!';
    setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = old; }, 1600);
  }

  // Cambia los libros sueltos por el kit completo (quita los libros y suma el kit)
  function swapToKit(btn) {
    if (busy) return;
    setBusy(true);
    btn.classList.add('is-loading');
    var updates = {};
    (btn.getAttribute('data-oe-cd-rm') || '').split(',').forEach(function (k) { if (k) updates[k] = 0; });
    var chain = Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : Promise.resolve();
    chain
      .then(function () { return post('/cart/add.js', { items: [{ id: Number(btn.getAttribute('data-oe-cd-kit')), quantity: 1 }] }); })
      .then(refresh)
      .catch(function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  function init() {
    // Pagina /cart: cuando cambia el carrito, el contador del header se pone al dia
    function hookCartPage() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { updateCount(c.item_count || 0); })
          .catch(function () {});
      });
    }
    if (document.readyState === 'complete') hookCartPage(); else window.addEventListener('load', hookCartPage);
    root = q('[data-oe-cd]');
    if (!root) return;
    mount = q('[data-oe-cd-mount]', root);

    document.addEventListener('click', function (e) {
      var t = e.target;
      var closeBtn = t.closest('[data-oe-cd-close]');
      if (closeBtn) { e.preventDefault(); close(); return; }
      var qty = t.closest('[data-oe-cd-qty]');
      if (qty) {
        e.preventDefault();
        change(qty.getAttribute('data-oe-cd-qty'), Number(qty.getAttribute('data-q')), qty.closest('.oe-cd__item'));
        return;
      }
      var kit = t.closest('[data-oe-cd-kit]');
      if (kit) { e.preventDefault(); swapToKit(kit); return; }
      var add = t.closest('[data-oe-cd-add]');
      if (add) { e.preventDefault(); addVariant(add.getAttribute('data-oe-cd-add'), add); return; }
      var cart = t.closest('.oe-hdr__cart');
      if (cart && !e.metaKey && !e.ctrlKey) { e.preventDefault(); refresh().then(open); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // Cualquier formulario de "agregar al carrito" de la tienda
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btn = e.submitter || f.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '0.7'; }
      var fd = new FormData(f);
      if (btn && btn.hasAttribute('data-oe-now')) {
        // Comprar ahora: la compra es solo este producto y va directo al pago
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } }); })
          .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
          .catch(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; } f.submit(); });
        return;
      }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (r) { added(btn); return r; })
        .then(refresh)
        .then(open)
        .catch(function () { f.submit(); })
        .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; } });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
